import React from "react";
import CatMenuItems from "./CatMenuItems";
import classes from "./CatDropList.module.css";
const CatSubMenu = (props) => {
  return (
    props.isShown && (
      <ul className={`${classes["nav_menu-dropdown"]}  ${classes.sub_menu}`}>
        {props.submenu.map((menu, index) => (
          <CatMenuItems items={menu} key={index} depth={props.depth + 1} />
        ))}
      </ul>
    )
  );
};

export default CatSubMenu;
